<template>
  <resource-count-widget resource="orders">
    <div slot-scope="{total, today, compareMonthToLastYear, tagClass, tagIcon}" class="flex justify-between items-center">
      <div>
        <h3 class="uppercase text-gray tracking-wide text-sm">Commandes</h3>
        <span class="text-2xl text-gray-darker font-bold">{{ total }}</span>
      </div>
      <div class="flex flex-col items-end">
        <div class="text-gray mb-1">{{ today }} aujourd'hui</div>
        <vue-tag :icon="tagIcon" :class="tagClass">{{ Math.abs(compareMonthToLastYear) }}%</vue-tag>
      </div>
    </div>
  </resource-count-widget>
</template>

<script>
import ResourceCountWidget from '../widgets/ResourceCountWidget.vue';

export default {
  components: { ResourceCountWidget },
};
</script>
